import React from 'react';

/**
 * WalletConnect component
 * Prompts user to connect their MetaMask wallet
 */
function WalletConnect({ onConnect }) {
  return (
    <div className="wallet-connect-section">
      <div className="wallet-connect-card">
        <div className="icon-large">🔐</div>
        <h2>Connect Your Wallet</h2>
        <p>
          Connect your MetaMask wallet to start verifying AI-generated assignments
        </p>
        <button 
          className="btn btn-primary btn-large"
          onClick={onConnect}
        >
          <img 
            src="https://upload.wikimedia.org/wikipedia/commons/3/36/MetaMask_Fox.svg" 
            alt="MetaMask"
            style={{ width: '24px', marginRight: '10px' }}
          />
          Connect MetaMask
        </button>
        <p className="small-text">
          Make sure you're connected to Monad Testnet
        </p>
      </div>
    </div>
  );
}

export default WalletConnect;
